import { ApimProductUser } from './apim-user-models';

export class ScreeningFee {
	screeningFee: number;
	watchlistFee: number;
	bundleFee: number;
	currencyId: number;
	custom: boolean;
	tierLevelId: number;
	tierLevel: number;
	quantity: string;
}

export class ScreeningFeeCreate {
	screeningFee: number;
	watchlistFee: number;
	bundleFee: number;
	currencyId: number;
	tierLevelId: number;
	superhogUserId: string;
}

export class Tier {
	tierLevelId: number;
	tierLevel: number;
}

export class ScreeningApiUser extends ApimProductUser {
	screeningFees: ScreeningFee[];
}

export class ScreeningFeeForUser {
	tierLevel: number;
	quantity: string;
	screeningFee: number;
	watchlistFee: number;
	bundleFee: number;
}
